module.exports = __webpack_public_path__ + "kshitij-mob.f72808a1b368ccf039b93b8301dfa982.webp";